"use client"

import LargeGraphSVG from "images/Icons/GraphL.inline.svg"
import SmallGraphSVG from "images/Icons/GraphM.inline.svg"
import LargeSetSVG from "images/Icons/SetL.inline.svg"
import SmallSetSVG from "images/Icons/SetM.inline.svg"
import LargeUsersSVG from "images/Icons/UsersL.inline.svg"
import SmallUsersSVG from "images/Icons/UsersM.inline.svg"
import { InfiniteSideScroll } from "library/InfiniteSideScroll"
import { css, f, styled } from "library/styled"
import { useMedia } from "library/useMedia"
import { Fragment } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function Marquee() {
	const marqueeSpeed = useMedia(0.4, 0.4, 0.3, 0.2)
	const marqueeItems = [
		{
			id: 1,
			text: "For businesses",
			largeIcon: LargeSetSVG,
			smallIcon: SmallSetSVG,
		},
		{
			id: 2,
			text: "For employees",
			largeIcon: LargeUsersSVG,
			smallIcon: SmallUsersSVG,
		},
		{
			id: 3,
			text: "For Brokers",
			largeIcon: LargeGraphSVG,
			smallIcon: SmallGraphSVG,
		},
	]

	return (
		<Wrapper>
			<MarqueeWrapper marqueeSpeed={marqueeSpeed} disableDrag>
				{marqueeItems.map((item) => {
					const LargeIcon = item.largeIcon
					const SmallIcon = item.smallIcon

					return (
						<Fragment key={item.id}>
							<MarqueeItem>
								<MarqueeText>{item.text}</MarqueeText>
								<MarqueeIcon>
									<LargeIcon />
								</MarqueeIcon>
								<SmallMarqueeIcon>
									<SmallIcon />
								</SmallMarqueeIcon>
							</MarqueeItem>
						</Fragment>
					)
				})}
			</MarqueeWrapper>
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...f.responsive(css`
		position: relative;
		width: 100%;
		margin: -2px auto 0;
		padding: 2px 0;
		user-select: none;
		background: ${colors.offWhite};
		z-index: 2;
	`),
	...f.tablet(css`
		width: 1024px;
	`),
	...f.mobile(css`
		width: 375px;
	`),
})

const pseudoElementBase = css`
	content: "";
	position: absolute;
	z-index: 2;
	top: 50%;
	transform: translateY(-50%);
	height: 192px;
`

const MarqueeWrapper = styled(InfiniteSideScroll, {
	...f.responsive(css`
		position: relative;
		margin: 0 auto;
		padding: 140px 0;
		overflow: clip;
		width: 1440px;
		height: 383px;

		&::before {
			${pseudoElementBase};
			left: 0;
			width: 200px;
			background: linear-gradient(
				270deg,
				rgba(251 250 246 / 0%) 0%,
				#fbfaf6 85.03%
			);
		}

		&::after {
			${pseudoElementBase};
			right: 0;
			width: 210px;
			background: linear-gradient(
				90deg,
				rgba(251 250 246 / 0%) 0%,
				#fbfaf6 84.42%
			);
		}
	`),

	...f.tablet(css`
		width: 1024px;
	`),
	...f.mobile(css`
		width: 375px;
		padding: 80px 0;

		&::before {
			width: 64px;
			height: 192px;
		}

		&::after {
			width: 64px;
			height: 192px;
		}
	`),
})

const MarqueeItem = styled("div", {
	...f.responsive(css`
		display: flex;
		align-items: center;
		position: relative;
		z-index: 1;
		padding-bottom: 24px;
	`),
	...f.mobile(css`
		padding-bottom: 0;
	`),
})

const MarqueeText = styled("p", {
	...f.responsive(css`
		${textStyles.h1};
		color: ${colors.green400};
	`),
	...f.mobile(css`
		${textStyles.h6};
	`),
})

const iconBase = css`
	display: block;
	margin: 0 24px;

	svg {
		path {
			stroke: ${colors.green400};
		}
	}
`

const MarqueeIcon = styled("div", {
	...f.responsive(css`
		${iconBase};
		width: 50px;
		height: 50px;
	`),
	...f.mobile(css`
		display: none;
	`),
})

const SmallMarqueeIcon = styled("div", {
	...f.responsive(css`
		display: none;
	`),
	...f.mobile(css`
		${iconBase};
		width: 32px;
		height: 32px;
	`),
})
